import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4c2h68ok: FaireBrandEntity = {
  token: "b_4c2h68ok",
  type: "brand",
  name: "Mary Meyer",
  avatarUrl:
    "https://cdn.faire.com/fastly/57fdc276ef2bbb131b024202bed65d8a989d02efa5044424425f09723c18e2f7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d2fc7b20d5ab5b4cfe1e2479652d10b9f064a7f32b7aa939aa1f849ffc8499f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/57fdc276ef2bbb131b024202bed65d8a989d02efa5044424425f09723c18e2f7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d2fc7b20d5ab5b4cfe1e2479652d10b9f064a7f32b7aa939aa1f849ffc8499f.jpeg",
  location: "Townshend, VT, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 151,
  isTopShop: true,
  isInsider: true,
  description:
    "Mary Meyer was a young wife and mother who began sewing animal pin cushions that later became stuffed animal toys. Inventive, driven, and compassionate, Mary built a company that continues to bring joy to children and families worldwide with care, quality, and love. This intention has been passed down two generations to Mary’s grandsons, who run the company today because this is who Mary Meyer was, and this is what the company she started is all about. Love you can feel®. All our toys are built to meet the highest quality and safety standards to ensure that a Mary Meyer friend is a friend for life. As much as the softest fabrics and sweetest faces define our characters, it takes craft, care, and no small amount of creativity to make a true Mary Meyer toy. Made with love for secret conversations and never-ending cuddles, our companions come from Mary’s belief that “Every child deserves something wonderful to love.”",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:22.978Z",
    importedBy: "entity-db-cli",
  },
};
